import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
    FormControl,
    TextField
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { EditIcon } from '../../../vectors/index';
import Done from '@mui/icons-material/Done';
import { Employer } from '../types';
import { useExtendTrial } from '../hooks/useExtendTrial';

type ExtendTrialProps = {
    handleClose: () => void;
    item: Employer;
    paidCheck?: boolean
};

const ExtendTrial: FC<ExtendTrialProps> = ({
    handleClose,
    item,
    paidCheck
}) => {

    const [errorText, setErrorText] = useState<string>('');
    const [trial, setExtendTrial] = useState<string>('0');

    const { extendTrial, isExtendTrialLoading } = useExtendTrial({ setErrorText })

    const handleDelete = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message)
                handleClose();
            },
        };

        extendTrial({ company_id: item.company.id, trial_length: trial }, options)
    }

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <EditIcon />
                <br />
                <Typography variant="h6" >
                    {paidCheck ? 'Create Trial' : ' Extend Trial'}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <FormControl sx={{ marginBottom: "10px" }} fullWidth>
                    <Typography mb={2} id="pay-rate-type-label">{paidCheck ? 'Days To Allow Trial' : 'Days To Extend Trial'} </Typography>
                    <TextField
                        variant="outlined"
                        type="number"
                        inputMode="numeric"
                        value={trial}
                        inputProps={{ min: 0 }}
                        onChange={(e) => setExtendTrial(e.target.value)}
                        fullWidth
                        size='small'
                    />
                </FormControl>
                <LoadingButton
                    loading={isExtendTrialLoading}
                    disabled={isExtendTrialLoading || !trial}
                    fullWidth
                    startIcon={<Done />}
                    variant="contained" color="primary" onClick={handleDelete}>
                    Save
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default ExtendTrial;
